import { useFetchPageV2 } from "~/core/composables/useFetchPageV2";
import { SearchMode, useSearch } from "~/core/composables/useSearch";
import { useSort } from "~/core/composables/useSort";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_ANY_MATCH,
  OPERATOR_RSQL_ILIKE,
} from "~/core/models/filters";
import filtersUtils from "~/core/utils/filters.utils";
import CampaignOperationMgrService from "~/modules/campaign/services/campaignOperationMgr.service";

export function useFetchCampaigns({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const service = CampaignOperationMgrService.findWithPagination.bind(
    CampaignOperationMgrService,
  );

  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.NAME,
      {
        key: "name",
        operator: OPERATOR_RSQL_ILIKE,
        value: "",
        valueFormatter: filtersUtils.formatRSQLValue,
      },
    ],
    [
      Filters.SECTORS,
      {
        key: "operationSectorCodeList",
        operator: OPERATOR_RSQL_ANY_MATCH,
        value: "",
      },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
    SearchMode.URL_SEARCH,
  );
  const { sort, onSortChange } = useSort();
  const { isLoading, results, error, fetchData } = useFetchPageV2({
    service,
    searchParams,
    sort,
    useQueryParametersForPagination: true,
    organizationCode,
  });

  return {
    isLoading,
    error,
    results,
    filters,
    fetchData,
    setFilter,
    onSortChange,
    search,
    onSearch,
    sort,
  };
}
